import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

export default function Questions({ dir }) {
  const { t, i18n } = useTranslation();
  const TitleStyle = {
    borderRight: dir === 'rtl' ? '6px solid' : 'none',
    borderLeft: dir === 'ltr' ? '6px solid' : 'none',
  };

  return (
    <div>
      <div className="row justify-content-evenly">
        <div className="col-md-11 headlineContainer">
          <h2 className="Title px-2 my-4  wow fadeInLeft" data-wow-delay="0.3s" >
            <div className='indicator'></div>
            <Trans i18nKey="FAQTitle">الأسئلة الشائعة</Trans>
          </h2>
        </div>
        <div className="col-md-11">
            <h3 className=" wow fadeIn  px-2 justify-margin " style={{fontFamily:'saudi'}} data-wow-delay="0.6s" >
            <Trans i18nKey="FAQSubtitle">إجابات واضحة على أسئلتك القانونية</Trans>
          </h3>
        </div>
        <div className="col-md-11">
          <div className="row justify-content-end">
            <div className="col-md-10 col-xl-8">
              <div className="faq-content wow fadeIn " data-wow-delay="0.6s">
                <div className="faq-question mb-3">
                  <input 
                    id="q1" 
                    type="checkbox" 
                    className="panel" 
                    aria-label={t("FAQQ1", "كيف يمكنني الحصول على استشارة قانونية؟")}
                  />
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col">
                        <h3 className="panel-title">
                          <Trans i18nKey="FAQQ1">كيف يمكنني الحصول على استشارة قانونية؟</Trans>
                        </h3>
                      </div>
                      <div className="col-auto">
                        <label htmlFor="q1" aria-label={t("toggleFAQ", "Toggle FAQ answer")}>
                          <i className="fa-solid fa-angle-down panel-title p-1" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="panel-content">
                    <p>
                      <Trans i18nKey="FAQA1">يمكنك التواصل معنا عبر النموذج الإلكتروني أو الاتصال المباشر لتحديد موعد استشارة.</Trans>
                    </p>
                  </div>
                </div>
                <div className="faq-question mb-3">
                  <input 
                    id="q2" 
                    type="checkbox" 
                    className="panel" 
                    aria-label={t("FAQQ2", "ما أنواع العقود التي تقدمونها؟")}
                  />
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col">
                        <h3 className="panel-title">
                          <Trans i18nKey="FAQQ2">ما أنواع العقود التي تقدمونها؟</Trans>
                        </h3>
                      </div>
                      <div className="col-auto">
                        <label htmlFor="q2" aria-label={t("toggleFAQ", "Toggle FAQ answer")}>
                          <i className="fa-solid fa-angle-down panel-title p-1" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="panel-content">
                    <p>                    
                      <Trans i18nKey="FAQA2">نقوم بصياغة ومراجعة العقود التجارية، المدنية، وعقود الشراكة، لضمان حمايتك القانونية.</Trans>
                     </p>
                  </div>
                </div>
                <div className="faq-question mb-3">
                  <input 
                    id="q3" 
                    type="checkbox" 
                    className="panel" 
                    aria-label={t("FAQQ3", "هل تقدمون خدمات للشركات فقط أم للأفراد أيضًا؟")}
                  />
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col">
                        <h3 className="panel-title">
                          <Trans i18nKey="FAQQ3">هل تقدمون خدمات للشركات فقط أم للأفراد أيضًا؟</Trans>
                        </h3>
                      </div>
                      <div className="col-auto">
                        <label htmlFor="q3" aria-label={t("toggleFAQ", "Toggle FAQ answer")}>
                          <i className="fa-solid fa-angle-down panel-title p-1" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="panel-content">
                    <p>              
                       <Trans i18nKey="FAQA3">نحن نقدم خدماتنا لكل من الشركات والأفراد، وفق احتياجاتهم القانونية المختلفة.</Trans>
                   </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}